import React from 'react';

const CHROMELESS_RESET_ID = 'chromeless-reset-styles';

interface Props {
  children: React.ReactNode;
}

/**
 * Wrapper that injects critical CSS resets for chromeless pages (payment checkout, SSO, etc.)
 * that don't use AppShell. AppShell normally provides these resets, but chromeless
 * routes skip AppShell entirely.
 */
export const ChromelessLayout: React.FC<Props> = ({ children }) => {
  React.useLayoutEffect(() => {
    if (document.getElementById(CHROMELESS_RESET_ID)) return;
    const style = document.createElement('style');
    style.id = CHROMELESS_RESET_ID;
    style.textContent = [
      'html,body{height:100%;margin:0;padding:0}',
      '#app{height:100%}',
    ].join('');
    document.head.appendChild(style);
    return () => {
      document.getElementById(CHROMELESS_RESET_ID)?.remove();
    };
  }, []);

  return <>{children}</>;
};
